import PropTypes from 'prop-types';
import React from 'react';

// eslint-disable-next-line no-unused-vars
const Tab = ({ url, label, children }) => (
  <React.Fragment>
    {children}
  </React.Fragment>
);

Tab.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired
};

export default Tab;
